import React, { useState } from 'react';
import { useIntl } from '../../util/reactIntl';
import { Avatar, UserDisplayName } from '../../components';
import css from './SectionReviews.module.css';

const INITIAL_COUNT = 3;

const StarDisplay = ({ rating, max = 5 }) => {
  const filled = Math.round(rating || 0);
  return (
    <span className={css.stars}>
      {'★'.repeat(filled)}{'☆'.repeat(max - filled)}
    </span>
  );
};

const ReviewCard = ({ review }) => {
  const intl = useIntl();
  const [expanded, setExpanded] = useState(false);

  const date = review.attributes.createdAt;
  const dateString = intl.formatDate(date, { month: 'long', year: 'numeric' });
  const rating = review.attributes.rating;
  const content = review.attributes.content || '';
  const isLong = content.length > 200;

  return (
    <div className={css.reviewCard}>
      <div className={css.reviewHeader}>
        <Avatar className={css.reviewAvatar} user={review.author} />
        <div className={css.reviewMeta}>
          <span className={css.reviewerName}>
            <UserDisplayName user={review.author} intl={intl} />
          </span>
          <span className={css.reviewDate}>{dateString}</span>
        </div>
        <StarDisplay rating={rating} />
      </div>
      <p className={expanded ? css.reviewTextExpanded : css.reviewText}>{content}</p>
      {isLong ? (
        <button
          type="button"
          className={css.expandBtn}
          onClick={() => setExpanded(e => !e)}
        >
          {expanded ? 'Show less' : 'Read more'}
        </button>
      ) : null}
    </div>
  );
};

const SectionReviews = props => {
  const { reviews = [], fetchReviewsError } = props;
  const [showAll, setShowAll] = useState(false);

  if (fetchReviewsError) return null;
  if (!reviews || reviews.length === 0) return null;

  const avg = reviews.reduce((sum, r) => sum + (r.attributes?.rating || 0), 0) / reviews.length;
  const visible = showAll ? reviews : reviews.slice(0, INITIAL_COUNT);
  const hasMore = reviews.length > INITIAL_COUNT;

  return (
    <section className={css.root}>
      <div className={css.summary}>
        <span className={css.avgNumber}>{avg.toFixed(1)}</span>
        <div className={css.summaryRight}>
          <StarDisplay rating={avg} />
          <span className={css.reviewCount}>
            {reviews.length} {reviews.length === 1 ? 'review' : 'reviews'}
          </span>
        </div>
      </div>

      <div className={css.reviewList}>
        {visible.map(r => (
          <ReviewCard key={`Review_${r.id.uuid}`} review={r} />
        ))}
      </div>

      {hasMore && !showAll ? (
        <button type="button" className={css.showAllBtn} onClick={() => setShowAll(true)}>
          Show all reviews ({reviews.length})
        </button>
      ) : null}
    </section>
  );
};

export default SectionReviews;
